import { Inject, Component } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import { FormArray, FormControl, UntypedFormArray, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { slugify } from '../helpers';

export interface DialogData {
  id: number;
  name: string;
  shortcode: string;
  description: string;
}
@Component({
  selector: 'app-merch-item-details',
  templateUrl: './merch-item-details.component.html',
  styleUrls: ['./merch-item-details.component.scss']
})
export class MerchItemDetailsComponent {
  constructor(
    // @Inject('$rootScope') private $rootScope: any,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public dialogRef: MatDialogRef<any>,
    private http: HttpClient,
  ) {
    this.merchForm.patchValue(data);

    if(data.id)
      this.http.get<any>(environment.apiSrc + '/merch/item/' + data.id).subscribe(
        data => {
          this.merchForm.patchValue({
            name: data.name,
            shortcode: data.shortcode,
            description: data.description,
            price: data.price,
            weight: data.weight,
            tax: data.tax,
            public: data.public,
            images: data.images,
            params: data.params,
            type: data.type
          });

          let prices = this.merchForm.get('price') as FormArray;
          prices.clear({ emitEvent: false });
      
          data.price.forEach(i => 
            prices.push(new UntypedFormControl(i), { emitEvent: false })
          )

          let images = this.merchForm.get('images') as FormArray;
          images.clear({ emitEvent: false });
      
          data.images.forEach(i => 
            images.push(new UntypedFormGroup({
              id: new UntypedFormControl(i.id),
              src: new UntypedFormControl(i.src), 
              caption: new UntypedFormControl(i.caption), 
            }), { emitEvent: false })
          )


          let params = this.merchForm.get('params') as FormArray;
          params.clear({ emitEvent: false });
      
          data.params.forEach(i => 
            params.push(new UntypedFormGroup({
              id: new UntypedFormControl(i.id),
              merch_id: new UntypedFormControl(i.merch_id),
              type: new UntypedFormControl(i.type), 
              option: new UntypedFormControl(i.option), 
              value: new UntypedFormControl(i.value), 
              inventory: new UntypedFormControl(i.inventory), 
              weight: new UntypedFormControl(i.weight), 
            }), { emitEvent: false })
          )
          // _this.locals.item = response.data;
        }
      );
  }

  saved = false;
  newImage;
  
  options = [ 
    { type: '', option: ''},
    { type: 'size', option: 'Size'},
    { type: 'colour', option: 'Colour'},
    { type: 'pack', option: 'Pack'},
  ]

  catList = [ "tshirt", "tote", "sticker", "socks", "pins-patches", "hat", "general", "coasters-coolers" ];
    

  files: any[] = [];

  ngOnInit() {
    this.merchForm.controls['name'].valueChanges.subscribe( name => {
      this.merchForm.patchValue({ shortcode: slugify(name) })
    })
  }

  fileBrowseHandler(target ) {
    this.prepareFilesList(target.files);
  }


  prepareFilesList(files: Array<any>) {
    for (const item of files) {
      item.progress = 0;
      this.files.push(item);
    }
    this.uploadCover();
    // this.uploadFilesSimulator(0);
  }

  uploadCover() { 
    if (!this.files.length) {
      return;
    } else {
      const formData = new FormData();
      formData.append('file', this.files[0]);
      formData.append('merchId', this.merchForm.value.id);
      formData.append('merchShortcode', this.merchForm.value.shortcode);

      this.http.post<any>(environment.musicDBapiSrc + '/coverupload', formData).subscribe(
        data => { 
          // this.newImage = data;

          let images = this.merchForm.get('images') as FormArray;
          images.clear({ emitEvent: false });
      
          images.push(new UntypedFormGroup({
            id: new UntypedFormControl(),
            src: new UntypedFormControl(data.image), 
            caption: new UntypedFormControl(''), 
          }), { emitEvent: true })
          this.merchForm.markAsDirty();

          this.deleteFile(0);
         }
      )
    }
  }

  deleteFile(index: number) {
    this.files.splice(index, 1);
  }


  saveItem() {
    console.log(this.merchForm.value.id)
    this.saved = true;
    this.http.post(environment.apiSrc +'/merch/item', this.merchForm.value ).subscribe( data => {
      // this.dialogRef.close(this.merchForm.value)
    });
  }

  alterOptions(param, opt) {
    console.log(param, opt);

    let params = this.merchForm.get('params') as FormArray;
    params.controls[param].patchValue({option: opt.option});
  }

  removeOption(param) {
    let params = this.merchForm.get('params') as FormArray;
    console.log(params, param)
    params.removeAt(param, {emitEvent: true});
    this.merchForm.markAsDirty();

  }

  addOption() {
    let params = this.merchForm.get('params') as FormArray;
    
    params.push(new UntypedFormGroup({
      id: new UntypedFormControl(null),
      merch_id: new UntypedFormControl(this.merchForm.value.id),
      type: new UntypedFormControl(''), 
      option: new UntypedFormControl(''), 
      value: new UntypedFormControl(''), 
      inventory: new UntypedFormControl(0), 
      weight: new UntypedFormControl(0), 
    }), { emitEvent: false })
  }

  merchForm = new UntypedFormGroup({
    id: new UntypedFormControl(),
    name: new UntypedFormControl(),
    shortcode: new UntypedFormControl(),
    description: new UntypedFormControl(),
    price: new UntypedFormArray([new UntypedFormControl(), new UntypedFormControl(),]),
    weight: new UntypedFormControl(),
    tax: new UntypedFormControl(true),
    public: new UntypedFormControl(false),
    images: new UntypedFormArray([]),
    params: new UntypedFormArray([]),
    type: new UntypedFormControl()
  })
}
